import { NavigationProp, RouteProp, useLinkTo } from "@react-navigation/native";
import { useAtomValue } from "jotai";
import { useEffect } from "react";

import { Loader } from "@whoosh/design-system/src/components/display";

import { sessionClubsAtom } from "../features/Session";
import { BaseNavigatorParamList } from "./BaseNavigator/types";

type Props = {
  route: RouteProp<BaseNavigatorParamList, "Legacy">;
  navigation: NavigationProp<BaseNavigatorParamList>;
};

export const LegacyRedirect = ({ route, navigation }: Props) => {
  const linkTo = useLinkTo();
  const userClubs = useAtomValue(sessionClubsAtom);

  const { path } = route;

  useEffect(() => {
    // We don't have a session yet, so redirect to the unauthenticated screen
    if (userClubs && path) {
      if (userClubs.length === 0) {
        setTimeout(() => {
          navigation.navigate("Unauthenticated");
        });
      }

      const defaultClubSlug = userClubs[0].slug;

      if (path.includes("/members/private/booking-detail/")) {
        const bookingPath = path.replace(
          "/members/private/booking-detail/",
          `/patron/club/${defaultClubSlug}/booking/`
        );
        setTimeout(() => {
          linkTo(bookingPath);
        });
      }
      // Agenda Route Changed from "booking" -> "agenda"
      else if (path.includes("/members/private/booking/")) {
        const agendaPath = path.replace(
          "/members/private/booking",
          `/patron/club/${defaultClubSlug}/agenda`
        );
        setTimeout(() => {
          linkTo(agendaPath);
        });

        // Booking Detail Route Changed from "booking-detail" -> "booking"
      } else if (path.includes("/members/private")) {
        // Catch Everything Else
        const newPath = path.replace(
          "/members/private",
          `/patron/club/${defaultClubSlug}`
        );
        setTimeout(() => {
          linkTo(newPath);
        });
      }
    }
  }, [linkTo, navigation, path, userClubs]);

  return <Loader />;
};
